/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedTrackingContainer_user = {
    readonly serviceId: string | null;
    readonly isVerifiedTrade: boolean | null;
    readonly " $fragmentRefs": FragmentRefs<"SharedTrackingContainer_user">;
    readonly " $refType": "SbSharedTrackingContainer_user";
};
export type SbSharedTrackingContainer_user$data = SbSharedTrackingContainer_user;
export type SbSharedTrackingContainer_user$key = {
    readonly " $data"?: SbSharedTrackingContainer_user$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedTrackingContainer_user">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbSharedTrackingContainer_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isVerifiedTrade",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SharedTrackingContainer_user",
      "args": null
    }
  ]
};
(node as any).hash = 'ed8c22748cc9074e7803de32918e8933';
export default node;
